import { render, staticRenderFns } from "./resourceStoreSpecificationManageList.vue?vue&type=template&id=a439bb18&scoped=true"
import script from "./resourceStoreSpecificationManageList.vue?vue&type=script&lang=js"
export * from "./resourceStoreSpecificationManageList.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreSpecificationManageList.vue?vue&type=style&index=0&id=a439bb18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a439bb18",
  null
  
)

export default component.exports